const ServiceBuyerData = 
{
  links: {
    next: "",
    previous: ""
  },
  results: [
  {
    email: "buyer1@example.com",
    company_name: "Global Imports Ltd.",
    preferred_source_country: "China",
    product_name: "LED Light Bulbs",
    mobile_number: "+91-9876543210",
    short_description: "Looking to import energy-efficient LED light bulbs.",
    hsn_code: "9405",
    quantity: 5000,
    unit: "pieces",
    destination_port: "Nhava Sheva, India",
    inco_term: "FOB",
    payment_term: "LC",
    target_price: 25,
    is_negotiable: true,
    attachment: "invoice_led_bulbs.pdf"
  },
  {
    email: "seller2@tradehub.com",
    company_name: "AgroExports Co.",
    preferred_source_country: "India",
    product_name: "Basmati Rice",
    mobile_number: "+91-8765432109",
    short_description: "Premium grade Basmati rice available for export.",
    hsn_code: "1006",
    quantity: 10000,
    unit: "kg",
    destination_port: "Dubai Port",
    inco_term: "CIF",
    payment_term: "Advance",
    target_price: 65,
    is_negotiable: false,
    attachment: "basmati_offer_sheet.pdf"
  },
  {
    email: "buyer3@steeltrade.com",
    company_name: "Steel Traders Pvt Ltd",
    preferred_source_country: "South Korea",
    product_name: "Hot Rolled Coils",
    mobile_number: "+91-9988776655",
    short_description: "Import requirement for structural steel coils.",
    hsn_code: "7208",
    quantity: 300,
    unit: "tons",
    destination_port: "Chennai Port",
    inco_term: "EXW",
    payment_term: "TT",
    target_price: 48000,
    is_negotiable: true,
    attachment: "hr_coils_spec.pdf"
  },
  {
    email: "seller4@herbalworld.com",
    company_name: "Herbal World Inc.",
    preferred_source_country: "Sri Lanka",
    product_name: "Herbal Essential Oils",
    mobile_number: "+94-712345678",
    short_description: "Pure and organic essential oils for cosmetic use.",
    hsn_code: "3301",
    quantity: 200,
    unit: "litres",
    destination_port: "Colombo Port",
    inco_term: "DDP",
    payment_term: "Credit (30 Days)",
    target_price: 1200,
    is_negotiable: false,
    attachment: "oil_certifications.pdf"
  },
  {
    email: "buyer5@techdealers.com",
    company_name: "TechDealers International",
    preferred_source_country: "Germany",
    product_name: "Industrial Sensors",
    mobile_number: "+49-15123456789",
    short_description: "Need advanced sensors for industrial automation.",
    hsn_code: "9026",
    quantity: 150,
    unit: "units",
    destination_port: "Hamburg Port",
    inco_term: "DAP",
    payment_term: "LC at Sight",
    target_price: 3000,
    is_negotiable: true,
    attachment: "sensor_spec_sheet.pdf"
  }
]}

export default ServiceBuyerData;